"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getField = void 0;
const jsonpath_plus_1 = require("jsonpath-plus");
const getField = (source, path) => {
    const result = (0, jsonpath_plus_1.JSONPath)({ path, json: source });
    if (result && result.length > 0) {
        return result[0];
    }
    return undefined;
};
exports.getField = getField;
//# sourceMappingURL=utils.js.map